module.exports = __webpack_public_path__ + "static/media/welcome-actions.bbc15393.png";